
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { EstadisticaVentas, Cliente } from '@/__env/lib/Clientes';
import { WaitEntre } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: string = '';

        @Prop( { type: Cliente } )
        public Cliente: Cliente;
        @Watch( 'Cliente', { immediate: true } )
        onEmpresa()
        {
            this.buscar();
        }

        public Item: EstadisticaVentas = new EstadisticaVentas();
        async buscar()
        {

            await WaitEntre( 500, 1000 );
            this.Item = await EstadisticaVentas.actual( this.Cliente );
            this.Estado = 'ok';
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

        }


    }
